import {
  createRouter,
  // createWebHashHistory,
  createWebHistory,
} from "vue-router";
// import jwt_decode from 'jwt-decode';
import dashboardView from "../views/dashboardView.vue";
import i18n from "../i18n";

const ifAuthenticated = (to, from, next) => {
  if (localStorage.getItem("JwtToken")) {
    next();
    return;
  }
  next("/");
};

const checkGroupPermission = (requiredGroupIds) => {
  return (to, from, next) => {
    const GID = localStorage.getItem("GID");
    if (GID) {
      const groupId = Number(GID);
      if (requiredGroupIds.includes(groupId)) {
        next();
      } else {
        next("/"); // Redirect to home or an error page
      }
    } else {
      next("/"); // Redirect to home or login page if token is missing
    }
  };
};

const checkPagePermission = (pageName) => {
  return (to, from, next) => {
    const allowedPages = JSON.parse(
      localStorage.getItem("allowedPages") || "[]"
    );
    if (allowedPages.includes(pageName)) {
      next();
    } else {
      next("/"); // أو صفحة خطأ
    }
  };
};

const routes = [
  {
    path: "/",
    name: "login",
    component: () => import("../views/loginView.vue"),
  },
  {
    path: "/home",
    name: "home",
    beforeEnter: ifAuthenticated,
    component: () => import("../views/HomeView.vue"),
    children: [
      {
        path: "/referUsers",
        name: "referUsers",
        component: () => import("../views/referUsersView.vue"),
        beforeEnter: checkPagePermission("referUsers"),
      },
      {
        path: "/notifyRequests",
        name: "notifyRequests",
        component: () =>
          import("../views/NotifyRequests/notifyRequestView.vue"),
        beforeEnter: checkPagePermission("notifyRequests"),
      },

      // {
      //   path: "/chat",
      //   name: "chat",
      //   component: () => import("../views/chatView.vue"),
      //   beforeEnter: checkPagePermission("chat"),
      // },
      {
        path: "/chat",
        name: "chat",
        component: () => import("../views/chatV2View.vue"),
        beforeEnter: ifAuthenticated,
      },
      {
        path: "/departmentAdmin",
        name: "departmentAdmin",
        component: () => import("../views/departmentAdminView.vue"),
        beforeEnter: ifAuthenticated,
      },
      {
        path: "/stops",
        name: "stop points",
        component: () => import("../views/stopsView.vue"),
        beforeEnter: checkPagePermission("stops"),
      },
      {
        path: "/routes",
        name: "route",
        component: () => import("../views/routesView.vue"),
        beforeEnter: checkPagePermission("routes"),
      },
      {
        path: "/countries",
        name: "countries",
        component: () => import("../views/region/countriesView.vue"),
        beforeEnter: checkPagePermission("countries"),
      },
      {
        path: "/governates",
        name: "governates",
        component: () => import("../views/region/governateView.vue"),
        beforeEnter: checkPagePermission("governates"),
      },
      {
        path: "/areas",
        name: "areas",
        component: () => import("../views/region/areaView.vue"),
        beforeEnter: checkPagePermission("areas"),
      },
      {
        path: "/busType",
        name: "busType",
        component: () => import("../views/MainData/busTypeView.vue"),
        beforeEnter: checkPagePermission("busType"),
      },
      {
        path: "/color",
        name: "color",
        component: () => import("../views/MainData/colorView.vue"),
        beforeEnter: checkPagePermission("color"),
      },
      {
        path: "/docName",
        name: "docName",
        component: () => import("../views/MainData/docNameView.vue"),
        beforeEnter: checkPagePermission("docName"),
      },
      {
        path: "/make",
        name: "make",
        component: () => import("../views/MainData/makeView.vue"),
        beforeEnter: checkPagePermission("make"),
      },
      {
        path: "/model",
        name: "model",
        component: () => import("../views/MainData/modelView.vue"),
        beforeEnter: checkPagePermission("model"),
      },
      {
        path: "/facalities",
        name: "facalities",
        component: () => import("../views/MainData/facalitiesView.vue"),
        beforeEnter: checkPagePermission("facalities"),
      },
      {
        path: "/vehicleTypes",
        name: "vehicleTypes",
        component: () => import("../views/MainData/vehicleTypesView.vue"),
        beforeEnter: checkPagePermission("vehicleTypes"),
      },
      {
        path: "/year",
        name: "year",
        component: () => import("../views/MainData/yearView.vue"),
        beforeEnter: checkPagePermission("year"),
      },
      {
        path: "/Bus",
        name: "Bus",
        component: () => import("../views/BusView.vue"),
        beforeEnter: checkPagePermission("Bus"),
      },
      {
        path: "/rideCategory",
        name: "rideCategory",
        component: () => import("../views/MainData/rideCategoryView"),
        beforeEnter: checkPagePermission("Ride Category	"),
      },

      {
        path: "/captains",
        name: "Captains",
        component: () => import("../views/MainData/captainsView"),
        beforeEnter: checkPagePermission("captains"),
      },
      {
        path: "/captainActivation",
        name: "CaptainActivation",
        component: () => import("../components/Captain/CaptainActivation.vue"),
        beforeEnter: checkPagePermission("Captain Activation"),
      },

      {
        path: "/users",
        name: "users",
        component: () => import("../views/admin/usersView.vue"),
        beforeEnter: checkPagePermission("users"),
      },
      {
        path: "/pages",
        name: "pages",
        component: () => import("../views/admin/pagesView.vue"),
        beforeEnter: checkPagePermission("pages"),
      },
      {
        path: "/groups",
        name: "groups",
        component: () => import("../views/admin/groupsView.vue"),
        beforeEnter: checkPagePermission("groups"),
      },
      {
        path: "/groupPages",
        name: "groupPages",
        component: () => import("../views/admin/groupPageView.vue"),
        beforeEnter: checkPagePermission("group pages"),
      },
      {
        path: "/schedules",
        name: "schedules",
        component: () => import("../views/scheduleView.vue"),
        beforeEnter: checkPagePermission("schedules"),
      },
      {
        path: "/realRides",
        name: "realRides",
        component: () => import("../views/realRidesView.vue"),
        beforeEnter: checkPagePermission("real Rides"),
      },
      {
        path: "/realRidesBusType",
        name: "realRidesBusType",
        component: () => import("../views/realRidesBusTypeView.vue"),
        beforeEnter: checkPagePermission("live ops"),
      },
      {
        path: "/package",
        name: "package",
        component: () => import("../views/package/packageView.vue"),
        beforeEnter: checkPagePermission("package"),
      },
      {
        path: "/realRidesStretch",
        name: "realRidesStretch",
        component: () => import("../views/realRidesStretchView"),
        beforeEnter: checkPagePermission("Real Rides Stetch"),
      },
      {
        path: "/realRidesForSupply",
        name: "realRidesForSupply",
        component: () => import("../views/realRidesForSupplyView.vue"),
        beforeEnter: checkPagePermission("Real rides for supply"),
      },
      {
        path: "/dediction",
        name: "dediction",
        component: () => import("../views/MainData/dedictionView.vue"),
        beforeEnter: checkPagePermission("dediction"),
      },
      {
        path: "/captainChangeReasions",
        name: "captainChangeReasions",
        component: () =>
          import("../views/MainData/captainChangeReasionsView.vue"),
        beforeEnter: checkPagePermission("Captain Change Reasons"),
      },

      {
        path: "/employees",
        name: "employees",
        component: () => import("../views/MainData/employeesView.vue"),
        beforeEnter: checkPagePermission("Employees"),
      },
      {
        path: "/cancelReasons",
        name: "cancelReasons",
        component: () => import("../views/MainData/cancelReasonsView.vue"),
        beforeEnter: checkPagePermission("Cancel Reasons"),
      },
      {
        path: "/startEndReasons",
        name: "startEndReasons",
        component: () => import("../views/MainData/startEndReasonsView.vue"),
        beforeEnter: checkPagePermission("Start End Reasons"),
      },
      {
        path: "/captainTransactions",
        name: "captainTransactions",
        component: () =>
          import("../views/captainTransactions/captainTransactions.vue"),
        beforeEnter: checkPagePermission("captainTransactions"),
      },
      {
        path: "/users",
        name: "users",
        component: () => import("../views/MainData/usersView.vue"),
        beforeEnter: checkPagePermission("users"),
      },

      {
        path: "/search",
        name: "search",
        component: () => import("../views/search/searchVue.vue"),
        beforeEnter: checkPagePermission("search"),
      },
      {
        path: "/cacheLogs",
        name: "cacheLogs",
        component: () => import("../views/search/cacheLogsVue.vue"),
        beforeEnter: checkPagePermission("Cache Logs"),
      },
      {
        path: "/addNotificationsUser",
        name: "add Notifications to  User",
        component: () => import("../views/addNotificationsUserVue.vue"),
        beforeEnter: checkPagePermission("add Notifications to User"),
      },
      {
        path: "/SearchUsersHistories",
        name: "Search Users Histories",
        component: () =>
          import("../views/SearchUsersHistories/SearchUsersHistories.vue"),
        beforeEnter: checkPagePermission("Search Users Histories	"),
      },
      {
        path: "/scheduledRunSchedules",
        name: "scheduled Run Schedules",
        component: () =>
          import("../views/scheduledRunSchedules/scheduledRunSchedules.vue"),
        beforeEnter: checkPagePermission("scheduledRunSchedules"),
      },
      {
        path: "/userCancellationReason",
        name: "User Cancellation Reason",
        component: () =>
          import("../views/MainData/userCancellationReasonView.vue"),
        beforeEnter: checkPagePermission("User Cancellation Reason"),
      },
      {
        path: "/compensation",
        name: "compensation",
        component: () => import("../views/MainData/compensationView.vue"),
        beforeEnter: checkPagePermission("compensation"),
      },
      {
        path: "/tabPopup/:id", // Define route with parameter ':id'
        name: "tabPopup",
        component: () => import("../components/realRidesBusType/tabPopup.vue"),
      },
      {
        path: "/tabForContractorPopup/:id", // Define route with parameter ':id'
        name: "tabForContractorPopup",
        component: () =>
          import(
            "../components/TabPopupForContractor/tabForContractorPopup.vue"
          ),
      },
      {
        path: "/userDataPage/:id/:userId", // Define route with parameters ':id' and ':userId'
        name: "userDataPage",
        component: () =>
          import("../components/MainData/users/userDataPage.vue"),
      },

      {
        path: "/captainDetaials/:id", // Define route with parameter ':id'
        name: "captainDetaials",
        component: () =>
          import("../components/Captain/captainDetaialsPopup.vue"),
      },
      {
        path: "/contratorBusCaptainDetaials/:id", // Define route with parameter ':id'
        name: "contratorBusCaptainDetaials",
        component: () =>
          import(
            "../components/ContractorBusesCaptains/contratorBusCaptainDetaialsPopup.vue"
          ),
      },

      {
        path: "/captainTransactionsPage/:id", // Define route with parameter ':id'
        name: "captainTransactionsPage",
        component: () =>
          import(
            "../components/captainTransactions/captainTransactionsPage.vue"
          ),
        beforeEnter: checkGroupPermission([1, 12, 10, 5]), // Example group IDs with access
      },
      {
        path: "/printInvoiceForCaptain/:id", // Define route with parameter ':id'
        name: "printInvoiceForCaptain",
        component: () =>
          import(
            "../components/contractorTransaction/printInvoiceForCaptain.vue"
          ),
        beforeEnter: checkGroupPermission([1, 12, 10, 5]), // Example group IDs with access
      },
      {
        path: "/changePassword", // Define route with parameter ':id'
        name: "changePassword",
        component: () => import("../views/changePasswordView.vue"),
        beforeEnter: checkPagePermission("changePassword"),
      },
      {
        path: "/oldchat/:id", // Define route with parameter ':id'
        name: "chat history ",
        component: () => import("../components/chatOldView/oldChatView.vue"),
      },
      {
        path: "/profilePop/:id", // Define route with parameter ':id'
        name: "profilePop",
        component: () => import("../components/profile/profilePop.vue"),
      },

      {
        path: "/closedChats",
        name: "closed chats",
        component: () => import("../views/chatClosedView.vue"),
        beforeEnter: checkPagePermission("Closed chats"),
      },
      {
        path: "/chatsWaiting",
        name: "chats waiting to close",
        component: () => import("../views/chatWaitingToCloseView.vue"),
        beforeEnter: checkPagePermission("chats waiting to close"),
      },
      {
        path: "/redirectedChats",
        name: "Redirected chats",
        component: () => import("../views/chatRedirectionView.vue"),
        beforeEnter: checkGroupPermission([6, 8]), // Example group IDs with access
      },
      {
        path: "/usersOperationsTable",
        name: "usersOperations",
        component: () => import("../components/admin/usersOperationTable.vue"),
        beforeEnter: checkPagePermission("redirected chats"),
      },
      {
        path: "/usersSearch",
        name: "user Search",
        component: () =>
          import("../components/MainData/users/usersTableById.vue"),
        beforeEnter: checkPagePermission("usersSearch"),
      },
      {
        path: "/bookings",
        name: "bookings",
        component: () => import("../components/bookings/bookingTable.vue"),
        beforeEnter: checkPagePermission("bookings"),
      },
      {
        path: "/privateBusRequests",
        name: "privateBusRequests",
        component: () => import("../views/PrivateBusRequestsVue.vue"),
        beforeEnter: checkPagePermission("privateBusRequests"),
      },
      {
        path: "/routesDetails",
        name: "routesDetails",
        component: () => import("../views/routesDetailsView.vue"),
        beforeEnter: checkPagePermission("routesDetails"),
      },
      {
        path: "/realRideDetails",
        name: "realRideDetails",
        component: () => import("../views/realRideDetailsView.vue"),
        beforeEnter: checkPagePermission("realRideDetails"),
      },
      {
        path: "/bookingDetails",
        name: "bookingDetails",
        component: () => import("../views/bookingDetailsView.vue"),
        beforeEnter: checkPagePermission("bookingDetails"),
      },
      {
        path: "/bookingCount", // Define route with parameter ':id'
        name: "bookingCount",
        component: () => import("../views/bookingCountView.vue"),
        beforeEnter: checkPagePermission("bookingCount"),
      },
      {
        path: "/usersDetails", // Define route with parameter ':id'
        name: "usersDetails",
        component: () => import("../views/usersDetailsView.vue"),
        beforeEnter: checkPagePermission("usersDetails"),
      },
      {
        path: "/corporates", // Define route with parameter ':id'
        name: "corporates",
        component: () => import("../views/corporates/corporatesView.vue"),
        beforeEnter: checkPagePermission("corporates"),
      },
      {
        path: "/dashboard",
        name: "dashboard",
        component: dashboardView,
      },
      {
        path: "/corporateEmployees",
        name: "corporateEmployees",
        component: () => import("../views/corporateEmployeesView.vue"),
        beforeEnter: checkPagePermission("Corporate Employees"),
      },
      {
        path: "/appAds",
        name: "appAds",
        component: () => import("../views/MainData/appAdsView.vue"),
        beforeEnter: checkPagePermission("appAds"),
      },
      {
        path: "/corporatePercentage",
        name: "corporatePercentage",
        component: () =>
          import(
            "../views/MainData/corporatePercentageView.vue"
          ),
        beforeEnter: checkPagePermission("corporate Percentage"),
      },
      {
        path: "/welcomeBalanceTransactions",
        name: "welcomeBalanceTransactions",
        component: () =>
          import(
            "../views/MainData/welcomeBalanceTransactionsView.vue"
          ),
        beforeEnter: checkPagePermission("welcome Balance Transactions"),
      },
      {
        path: "/companies-with-routes",
        name: "companiesWithRoutes",
        component: () => import("../views/companiesWithRoutesView.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;

// Update document title on route change using i18n if available
router.afterEach((to) => {
  try {
    const globalI18n = i18n?.global;
    const te = globalI18n?.te?.bind(globalI18n);
    const t = globalI18n?.t?.bind(globalI18n);
    const i18nKey = to?.name ? `menu.${to.name}` : null;
    const translated = i18nKey && te && te(i18nKey) ? t(i18nKey) : null;
    const metaTitle = typeof to?.meta?.title === "function" ? to.meta.title(to) : to?.meta?.title;
    const raw = translated || metaTitle || to?.name || "REGO";
    document.title = `${raw} | REGO`;
  } catch (_) {
    document.title = "REGO";
  }
});
